import { render } from "./lists_user_search.vue?vue&type=template&id=f65a8ae4"
import script from "./lists_user_search.js?vue&type=script&lang=js"
export * from "./lists_user_search.js?vue&type=script&lang=js"

import "./lists_user_search.vue?vue&type=style&index=0&id=f65a8ae4&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__